// @flow
/* eslint-disable new-cap */
import {
  GEOMETRY_FORMATS,
  DEFAULT_GEOMETRY_FORMAT,
} from 'utils/geometryFormats';

import type { Feature2D } from 'flow-geojson';
import type { GeometryFormat } from 'utils/geometryFormats';

type GeometryFormatPlugin = {|
  tryParseFeature: string => boolean,
  parseFeature: string => ?Feature2D,
  serializeFeature: Feature2D => string,
|};

const pluginCache: { [string]: GeometryFormatPlugin } = {};

const resolvePlugin = async (plugin: string): Promise<GeometryFormatPlugin> => {
  if (!(plugin in pluginCache)) {
    pluginCache[
      plugin
    ] = new (await import(/* webpackChunkName: 'geom-[request]' */
    `utils/geometryFormats/${plugin}.format`)).default();
  }

  return pluginCache[plugin];
};

export async function tryParseFeature(text: string): Promise<boolean> {
  // eslint-disable-next-line no-restricted-syntax
  for (const format of Object.keys(GEOMETRY_FORMATS)) {
    const plugin = await resolvePlugin(format);
    if (plugin.tryParseFeature(text)) {
      return plugin.parseFeature(text);
    }
  }

  return false;
}

export async function parseFeature(
  text: string,
  format: GeometryFormat = DEFAULT_GEOMETRY_FORMAT
): Promise<?Feature2D> {
  return (await resolvePlugin(format)).parseFeature(text);
}

export async function serializeFeature(
  feature: Feature2D,
  format: GeometryFormat = DEFAULT_GEOMETRY_FORMAT
): Promise<string> {
  return (await resolvePlugin(format)).serializeFeature(feature);
}



// WEBPACK FOOTER //
// ./utils/geometry.js